import React, { useState } from 'react'
import { AutoComplete, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import { get } from '../../Common/api'
import { Color } from '../../Common/Color'

const highlight = (text, highlight) => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
  return <span> {parts.map((part, i) =>
    <span key={i} style={part.toLowerCase() === highlight.toLowerCase() ? { color: Color.red } : {}}>
      {part}
    </span>)
  } </span>
}

const renderItem = (e, search) => ({
  value: e.zip_code,
  key: e.id,
  extra: e,
  label: (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {highlight(e.normalized_name, search)}
      <span> {highlight(e.zip_code, search)} </span>
    </div>
  )
})

export default function ZipCodeSearchField ({ form }) {
  const { t } = useTranslation()
  const [options, setOptions] = useState([])

  const handleSearch = (search, callback) => {
    get('public/postal_places', { search }, (json) => {
      const newOptions = json.map((e) => renderItem(e, search))
      setOptions(newOptions)
      if (callback) {
        callback(json)
      }
    })
  }

  const onSelect = (value) => {
    form.setFieldValue('zip_code', value)
  }

  return (
    <AutoComplete
      dropdownMatchSelectWidth={350}
      options={options}
      onSearch={handleSearch}
      onSelect={onSelect}
    >
      <Input autoFocus={true} placeholder={t('Public.Search.placeholder')} />
    </AutoComplete>
  )
}
